import { extractCurrentOwnerIdentity } from '../../members/members-selectors';
import { normalizeReactions, resolveNextReactionData } from './comment-reaction-utils';
export const getReactionsState = (reactionsStateIN, memberState) => {
    const { reactions: stateReactions, total } = reactionsStateIN;
    const reactions = normalizeReactions(stateReactions);
    if (reactionsStateIN.type === 'IDLE') {
        return {
            pending: false,
            total,
            reactions,
            activeReaction: reactions.find((r) => r.hasReacted)?.reactionCode,
        };
    }
    return {
        ...resolveNextReactionData({
            state: reactionsStateIN,
            initiatorIdentity: extractCurrentOwnerIdentity(memberState),
        }),
        pending: true,
        activeReaction: reactionsStateIN.reactionCode,
    };
};
//# sourceMappingURL=comments-reaction-selectors.js.map